const defaultSettings = undefined;
export const getThankYouPageSettings = clientData => {
  if (!(clientData != null && clientData.thankYouPageSettings)) {
    return defaultSettings;
  }
  try {
    const stored = JSON.parse(clientData.thankYouPageSettings);
    const parsed = {
      title: stored == null ? void 0 : stored.title,
      message: stored == null ? void 0 : stored.message,
      buttonText: stored == null ? void 0 : stored.buttonText,
      buttonLink: stored == null ? void 0 : stored.buttonLink
    };
    if (parsed.title || parsed.message || parsed.buttonText) {
      return parsed;
    }
    return defaultSettings;
  } catch (_unused) {
    return defaultSettings;
  }
};
export const hasButtonLink = settings => {
  return Boolean(settings == null ? void 0 : settings.buttonLink);
};
//# sourceMappingURL=get-thank-you-page-settings.js.map